import { NgModule } from '@angular/core';
import { SharedModule } from '../shared';
import { RouterModule } from '@angular/router';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { EvaluationComponent } from './components/evaluation/evaluation.component';
import { StatisticsDatamanagementComponent } from './components/statistics-datamanagement/statistics-datamanagement.component';
import { StatisticsByWeekComponent } from './components/statistics-by-week/statistics-by-week.component';
import { OpenPaymentInfoComponent } from './components/open-payment-info/open-payment-info.component';
import { GeographicalDataComponent } from './components/geographical-data/geographical-data.component';
import { AgmCoreModule } from '@agm/core';
import { GrantedDiscountsComponent } from './components/granted-discounts/granted-discounts.component';
import {MyDateRangePickerModule} from 'mydaterangepicker';
import { CurrentLossComponent } from './components/current-loss/current-loss.component';
import { EnergyConsumptionComponent } from './components/power-consumption-markets/energy-consumption.component';

@NgModule({
  imports: [
    SharedModule,
    RouterModule,
    NgxDatatableModule,
    AgmCoreModule,
    MyDateRangePickerModule
  ],
  declarations: [
    EvaluationComponent,
    StatisticsDatamanagementComponent,
    StatisticsByWeekComponent,
    OpenPaymentInfoComponent,
    GeographicalDataComponent,
    GrantedDiscountsComponent,
    CurrentLossComponent,
    EnergyConsumptionComponent
  ]
})

export class EvaluationModule { }



// WEBPACK FOOTER //
// ./src/app/evaluation/evaluation.module.ts